module.exports = __webpack_public_path__ + "img/group_chat_cover.3a0fc2f3.png";